import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout';
import { createOrganization } from '../api/api';

export default function CreateOrganization() {
  const [form, setForm] = useState({
    name: '',
    employeesCount: '',
    hasItTeam: false,
    hasSecurityPolicy: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { updateOrganization } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const org = await createOrganization({
        name: form.name,
        employeesCount: form.employeesCount ? Number(form.employeesCount) : null,
        hasItTeam: form.hasItTeam,
        hasSecurityPolicy: form.hasSecurityPolicy,
      });
      updateOrganization(org.id);
      navigate(`/org/${org.id}/dashboard`);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <h1 className="text-2xl font-bold text-slate-100 mb-2">Criar Organização</h1>
      <p className="text-slate-400 mb-8">
        Cadastre sua cooperativa ou organização para iniciar as avaliações.
      </p>

      {error && (
        <div className="bg-red-500/15 text-red-400 border border-red-500/30 p-4 rounded-lg mb-6">{error}</div>
      )}

      <form onSubmit={handleSubmit} className="max-w-xl space-y-6">
        <div>
          <label className="block text-sm font-medium text-slate-300 mb-1">Nome da organização</label>
          <input
            type="text"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full input-base"
            placeholder="Ex: Cooperativa ABC"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-300 mb-1">Número de colaboradores</label>
          <input
            type="number"
            min="1"
            value={form.employeesCount}
            onChange={(e) => setForm({ ...form, employeesCount: e.target.value })}
            className="w-full input-base"
          />
        </div>
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id="hasItTeam"
            checked={form.hasItTeam}
            onChange={(e) => setForm({ ...form, hasItTeam: e.target.checked })}
            className="w-4 h-4 accent-cyan-500 rounded"
          />
          <label htmlFor="hasItTeam">Possui equipe de TI</label>
        </div>
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id="hasSecurityPolicy"
            checked={form.hasSecurityPolicy}
            onChange={(e) => setForm({ ...form, hasSecurityPolicy: e.target.checked })}
            className="w-4 h-4 accent-cyan-500 rounded"
          />
          <label htmlFor="hasSecurityPolicy">Possui política de segurança</label>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="px-6 py-3 bg-cyan-500 hover:bg-cyan-600 text-white font-semibold rounded-lg disabled:opacity-50"
        >
          {loading ? 'Criando...' : 'Criar Organização'}
        </button>
      </form>
    </Layout>
  );
}
